"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CampaignIdParamsSchema = exports.ListReplicaCampaignSnapshotQuerySchema = exports.ListReplicaCampaignQuerySchema = exports.UpdateReplicaCampaignsBodySchema = exports.UpdateReplicaCampaignSchema = exports.ListReplicaCampaignSnapshotResponseSchema = exports.ListReplicaCampaignResponseSchema = exports.ReplicaCampaignSnapshotSchema = exports.ReplicaCampaignSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
const apple_proxy_web_1 = require("../../apple-proxy-web");
const common_1 = require("./common");
exports.ReplicaCampaignSchema = (0, core_1.StrictObject)({
    ...common_1.ReplicaMetadataFields,
    body: apple_proxy_web_1.AppleProxyCampaignSchema,
    duration: core_1.DurationSchema,
});
exports.ReplicaCampaignSnapshotSchema = exports.ReplicaCampaignSchema;
/**
 * Response
 */
exports.ListReplicaCampaignResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.ReplicaCampaignSchema);
exports.ListReplicaCampaignSnapshotResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.ReplicaCampaignSnapshotSchema);
/**
 * Body
 */
exports.UpdateReplicaCampaignSchema = (0, core_1.StrictObject)({
    campaignRef: ruby_1.AppleProxyRefSchema,
    body: apple_proxy_web_1.AppleProxyCampaignSchema,
});
exports.UpdateReplicaCampaignsBodySchema = (0, core_1.StrictObject)({
    // This is ReplicaMetadataFields, but the apple campaign schema
    ...common_1.ReplicaCampaignMetadataFields,
    campaigns: typebox_1.Type.Array(exports.UpdateReplicaCampaignSchema),
});
/**
 * Parameters
 */
exports.ListReplicaCampaignQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({
    ...common_1.ReplicaMetadataQueryFields,
});
exports.ListReplicaCampaignSnapshotQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({
    ...common_1.ReplicaMetadataSnapshotQueryFields,
});
exports.CampaignIdParamsSchema = typebox_1.Type.Object({
    campaignId: core_1.IdSchema,
});
